import m from '../m.js'
import { language, LANGUAGES, setLanguage } from '../i18n.js'
import { icon } from '../icons.js'
import { keyBindingsView } from '../keyBindings.js'
import { LANE_WIDTHS, setSetting, settings } from '../settings.js'

/** Settings dialog: language and what cards show. Changes apply right away. */
export const settingsDialogView = m.withState(() => {
  let onClose
  const toggle = (key, label, hint) =>
    m('label.setting', { title: hint }, [
      m('input[type=checkbox]', {
        checked: settings[key],
        onchange: evt => setSetting(key, evt.target.checked),
      }),
      label,
    ])
  return attrs => {
    onClose = attrs.onclose
    return m(
      '.overlay',
      {
        onmousedown: evt => {
          if (evt.target === evt.currentTarget) onClose()
        },
      },
      [
        keyBindingsView(
          'settings',
          { esc: () => onClose() },
          { skipInInputs: false }
        ),
        m(
          '.dialog.settings',
          { role: 'dialog', 'aria-label': m.t('settings.title') },
          [
            m('.dialog-head', [
              m('h2', m.t('settings.title')),
              m('.spacer'),
              m(
                'button.icon-button',
                {
                  title: m.t('detail.close'),
                  'aria-label': m.t('detail.close'),
                  onclick: onClose,
                },
                icon('x')
              ),
            ]),
            m('fieldset', [
              m('legend', m.t('app.language')),
              Object.entries(LANGUAGES).map(([code, name]) =>
                m('label.setting', [
                  m('input[type=radio][name=language]', {
                    checked: language === code,
                    onchange: () => setLanguage(code),
                  }),
                  name,
                ])
              ),
            ]),
            m('fieldset', [
              m('legend', m.t('settings.laneWidth')),
              Object.keys(LANE_WIDTHS).map(width =>
                m('label.setting', [
                  m('input[type=radio][name=laneWidth]', {
                    checked: settings.laneWidth === width,
                    onchange: () => setSetting('laneWidth', width),
                  }),
                  m.t(`settings.laneWidth.${width}`),
                ])
              ),
            ]),
            m('fieldset', [
              m('legend', m.t('settings.board')),
              toggle(
                'hideIssuesWithPr',
                m.t('settings.hideIssuesWithPr'),
                m.t('settings.hideIssuesWithPrHint')
              ),
            ]),
            m('fieldset', [
              m('legend', m.t('settings.cards')),
              toggle(
                'cardLabels',
                m.t('settings.cardLabels'),
                m.t('settings.cardLabelsHint')
              ),
              toggle(
                'cardLinks',
                m.t('settings.cardLinks'),
                m.t('settings.cardLinksHint')
              ),
              toggle(
                'cardVscode',
                m.t('pr.vscode'),
                m.t('settings.cardVscodeHint')
              ),
              toggle(
                'cardCopyBranch',
                m.t('pr.copyBranch'),
                m.t('settings.cardCopyBranchHint')
              ),
            ]),
            m('fieldset', [
              m('legend', m.t('claude.title')),
              toggle(
                'claudeCli',
                m.t('claude.cli'),
                m.t('settings.claudeCliHint')
              ),
              toggle(
                'claudeVscode',
                m.t('claude.vscode'),
                m.t('settings.claudeVscodeHint')
              ),
            ]),
            m('p.muted.small', m.t('settings.local')),
          ]
        ),
      ]
    )
  }
})
